module.exports = __webpack_public_path__ + "img/brush.a3dcedc7.svg";